import React from 'react';
import { Field, Formik } from 'formik';
import { object } from 'yup';
import { TextField } from 'formik-material-ui';
import Button from "@material-ui/core/Button/Button";
import { Api } from '../../utils/api';
import { MaterialSelectFormik } from '../components/establishments-select-field.component';


const validationSchema = object().shape({
});

const handleSubmitting = (fn) => (values, actions) => {
  fn(values);
  actions.setSubmitting(false);
};


// OPÇOES VALENCIA //
const valencesToSelect = (options) => {
  return options.map(
    (option) => ({ value: option.id, label: option.name })
  );
};
const valencesOptionsPromise = () => {
  const api = new Api();
  return api.get('/valences')
    .then(res => res.data)
    .then(valencesToSelect);
};

// OPÇOES DISTRITO //
const districtsToSelect = (options) => {
  return options.map(
    (option) => ({ value: option.id, label: option.name })
  );
};
const districtsOptionsPromise = () => {
  const api = new Api();
  return api.get('/districts')
    .then(res => res.data)
    .then(districtsToSelect);
};


// OPÇOES CONCELHO //
const countiesToSelect = (options) => {
  return options.map(
    (option) => ({ value: option.id, label: option.name })
  );
};
const countiesOptionsPromise = () => {
  const api = new Api();
  return api.get('/counties')
    .then(res => res.data)
    .then(countiesToSelect);
};

// OPÇOES FREGUESIA //
const parishesToSelect = (options) => {
  return options.map(
    (option) => ({ value: option.id, label: option.name })
  );
};
const parishesOptionsPromise = () => {
  const api = new Api();
  return api.get('/parishes')
    .then(res => res.data)
    .then(parishesToSelect);
};

export const EstablishmentMainForm = ({
  onSubmit,
  establishment
}) => (
  <Formik
    initialValues={{
      id: establishment.id,
      name: establishment.name,
      entity: establishment.entity_name,
      valence_id: establishment.valence_id,
      address: establishment.address,
      zip_code_4: establishment.zip_code_4,
      zip_code_3: establishment.zip_code_3,
      postal_designation: establishment.postal_designation,
      district_id: establishment.district_id,
      county_id: establishment.county_id,
      parish_id: establishment.parish_id,
      latitude: establishment.latitude,
      longitude: establishment.longitude,
      website: establishment.website

    }}
    onSubmit={handleSubmitting(onSubmit)}
    validationSchema={validationSchema}
    validateOnChange={false}
    validateOnBlur={false}
    render={({
      values,
      handleSubmit,
      setFieldValue,
      setFieldTouched
    }) => {
      return (
        <form onSubmit={handleSubmit}>
          <div className="form_establishment100">
            <Field
              name="name"
              label="Nome do Equipamento"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={'' + values.name}
              fullWidth
            />
            <Field
              name="entity"
              label="Entidade associada"
              placeholder="Entidade"
              type="text"
              variant="outlined"
              margin="normal"
              component={TextField}
              onChange={setFieldValue}
              value={'' + values.entity}
              fullWidth
              disabled
            />
          </div>
          <Field
            name="valence_id"
            label="Valência"
            variant="outlined"
            margin="normal"
            optionsFetcher={valencesOptionsPromise}
            component={MaterialSelectFormik}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            value={'' + values.valence_id}
          />
          <Field
            name="address"
            label="Morada"
            type="text"
            variant="outlined"
            margin="normal"
            component={TextField}
            onChange={setFieldValue}
            value={'' + values.address}
            fullWidth
          />
          <Field
            name="zip_code_4"
            label="Código Postal (4)"
            type="number"
            variant="outlined"
            margin="normal"
            component={TextField}
            onChange={setFieldValue}
            value={'' + values.zip_code_4}
          />
          <Field
            name="zip_code_3"
            label="Código Postal (3)"
            type="number"
            variant="outlined"
            margin="normal"
            component={TextField}
            onChange={setFieldValue}
            value={'' + values.zip_code_3}
          />
          <Field
            name="postal_designation"
            label="Localidade"
            type="text"
            variant="outlined"
            margin="normal"
            component={TextField}
            onChange={setFieldValue}
            value={'' + values.postal_designation}
          />
          <Field
            className="ml-4"
            name="latitude"
            label="Latitude"
            placeholder="Latitude"
            type="text"
            variant="outlined"
            margin="normal"
            component={TextField}
            onChange={setFieldValue}
            value={'' + values.latitude}
          />
          <Field
            name="longitude"
            label="Longitude"
            placeholder="Longitude"
            type="text"
            variant="outlined"
            margin="normal"
            component={TextField}
            onChange={setFieldValue}
            value={'' + values.longitude}
          />
          <br />
          <div className="form_establishment_inline">
            <span className="form_establishment_width300">
              <Field
                name="district_id"
                label="Distrito"
                variant="outlined"
                margin="normal"
                optionsFetcher={districtsOptionsPromise}
                component={MaterialSelectFormik}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                value={'' + values.district_id}
              />
            </span>
            <span className="form_establishment_width300">
              <Field
                name="county_id"
                label="Concelho"
                variant="outlined"
                margin="normal"
                optionsFetcher={countiesOptionsPromise}
                component={MaterialSelectFormik}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                value={'' + values.county_id}
              />
            </span>
            <span className="form_establishment_width300">
              <Field
                name="parish_id"
                label="Freguesia"
                variant="outlined"
                margin="normal"
                optionsFetcher={parishesOptionsPromise}
                component={MaterialSelectFormik}
                onChange={setFieldValue}
                onBlur={setFieldTouched}
                value={'' + values.parish_id}
              />
            </span>
          </div>
          <br />
          <Field
            name="website"
            label="Website"
            placeholder="Website"
            type="text"
            variant="outlined"
            margin="normal"
            component={TextField}
            onChange={setFieldValue}
            value={'' + values.website}
            className="form_establishment_width600"
          />
          <br />
          <Button
            variant="contained"
            type="submit"
            size="small"
            style={{ marginTop: '20px' }}
          >
            Atualizar
          </Button>
        </form>
      );
    }} />
);
